import styles from './Badge.module.css';

import { Text } from '../../Text';

export type BadgeVariant = 'default' | 'recommended';

interface BadgeProps {
  text: string;
}
export function Badge(props: BadgeProps) {
  return (
    <Text role="status" variant="heading-12" className={styles.root}>
      {props.text}
    </Text>
  );
}
